import { jsx } from "react/jsx-runtime";
import React__default, { useRef, useMemo, useState, useCallback, useEffect } from "react";
import IMask from "imask";
import classnames from "../../utils/classnames.js";
import Input2 from "../Input/Input.js";
import '../Input/Input.css';/* empty css                  */
const InputMask = React__default.forwardRef(
  function InputMask2(props, antdRef) {
    const {
      mask,
      maskOptions: _maskOptions,
      value: _value,
      defaultValue,
      definitions,
      placeholder: inputPlaceholder,
      onPaste = (e) => e.preventDefault(),
      className,
      ...antdProps
    } = props;
    const innerRef = useRef(null);
    const maskOptions = useMemo(() => {
      return {
        mask,
        definitions: {
          "0": /[0-9]/,
          // @ts-ignore
          ..._maskOptions == null ? void 0 : _maskOptions.definitions,
          ...definitions
        },
        lazy: false,
        // make placeholder always visible
        ..._maskOptions
      };
    }, [mask]);
    const placeholder = useMemo(() => {
      if (typeof inputPlaceholder !== "undefined") {
        return inputPlaceholder;
      }
      return IMask.createPipe({ ...maskOptions, lazy: false })("");
    }, [inputPlaceholder, maskOptions]);
    const imask = useRef(null);
    const propValue = (typeof _value === "string" ? _value : defaultValue) || "";
    const lastValue = useRef(propValue);
    const [value, setValue] = useState(propValue);
    const _onEvent = useCallback((ev, execOnChangeCallback = false) => {
      var _a;
      const masked = imask.current;
      if (!masked) {
        return;
      }
      if (ev.target) {
        if (ev.target.value !== masked.value) {
          masked.value = ev.target.value;
          ev.target.value = masked.value;
          lastValue.current = masked.value;
        }
      }
      Object.assign(ev, {
        maskedValue: masked.value,
        unmaskedValue: masked.unmaskedValue
      });
      masked.updateValue();
      setValue(lastValue.current);
      if (execOnChangeCallback) {
        (_a = props.onChange) == null ? void 0 : _a.call(props, ev);
      }
    }, []);
    const _onAccept = useCallback((ev) => {
      if (!(ev == null ? void 0 : ev.target)) {
        return;
      }
      const input = innerRef.current;
      const masked = imask.current;
      if (!input || !masked) {
        return;
      }
      ev.target.value = masked.value;
      input.value = masked.value;
      lastValue.current = masked.value;
      _onEvent(ev, true);
    }, []);
    function updateMaskRef() {
      const input = innerRef.current;
      if (imask.current) {
        imask.current.updateOptions(maskOptions);
      }
      if (!imask.current && input) {
        imask.current = IMask(input, maskOptions);
        imask.current.on("accept", _onAccept);
      }
      if (imask.current && imask.current.value !== lastValue.current) {
        imask.current.value = lastValue.current;
        imask.current.alignCursor();
      }
    }
    function updateValue(value2) {
      lastValue.current = value2;
      const input = innerRef.current;
      const masked = imask.current;
      if (!(input && masked)) {
        return;
      }
      masked.value = value2;
      input.value = masked.value;
      lastValue.current = masked.value;
    }
    useEffect(() => {
      updateMaskRef();
      return () => {
        var _a;
        (_a = imask.current) == null ? void 0 : _a.destroy();
        imask.current = null;
      };
    }, [mask]);
    useEffect(() => {
      updateValue(propValue);
    }, [propValue]);
    const eventHandlers = useMemo(() => {
      return {
        onBlur(ev) {
          var _a;
          _onEvent(ev);
          (_a = props.onBlur) == null ? void 0 : _a.call(props, ev);
        },
        onPaste(ev) {
          var _a;
          lastValue.current = (_a = ev.clipboardData) == null ? void 0 : _a.getData("text");
          if (ev.target) {
            ev.target.value = lastValue.current;
          }
          _onEvent(ev, true);
          onPaste == null ? void 0 : onPaste(ev);
        },
        onFocus(ev) {
          var _a;
          _onEvent(ev);
          (_a = props.onFocus) == null ? void 0 : _a.call(props, ev);
        },
        [KEY_PRESS_EVENT]: (ev) => {
          var _a;
          _onEvent(ev, true);
          (_a = props[KEY_PRESS_EVENT]) == null ? void 0 : _a.call(props, ev);
        }
      };
    }, []);
    return /* @__PURE__ */ jsx(
      Input2,
      {
        placeholder,
        className: classnames("perxis-auto-input", className),
        ...antdProps,
        ...eventHandlers,
        onChange: (ev) => _onEvent(ev, true),
        value,
        ref: function handleInputMask(ref) {
          if (antdRef) {
            if (typeof antdRef === "function") {
              antdRef(ref);
            } else {
              antdRef.current = ref;
            }
          }
          if (ref == null ? void 0 : ref.input) {
            innerRef.current = ref.input;
            if (!imask.current) {
              updateMaskRef();
            }
          }
        }
      }
    );
  }
);
function keyPressPropName() {
  if (typeof navigator !== "undefined") {
    return navigator.userAgent.match(/Android/i) ? "onBeforeInput" : "onKeyPress";
  }
  return "onKeyPress";
}
const KEY_PRESS_EVENT = keyPressPropName();
export {
  InputMask as default
};
//# sourceMappingURL=InputMask.js.map
